// import { Text } from '@components/Text';
import 'react-phone-input-2/lib/style.css';
import clsx from 'clsx';
import type { ComponentPropsWithoutRef, FocusEvent, KeyboardEvent } from 'react';
import React from 'react';
import type { ErrorOption } from 'react-hook-form';
import ReactPhoneInput from 'react-phone-input-2';
import flagUa from '@/assets/icons/flag-ua.svg';
import inputStyles from '@/components/Input/Input.module.scss';
import { Text } from '../Text';
import styles from './PhoneInput.module.scss';
type Props = {
  className?: string;
  disabled?: boolean;
  error?: ErrorOption;
  errorClassName?: string;
  inputProps?: ComponentPropsWithoutRef<'textarea'>;
  isReadonly?: boolean;
  isRequired?: boolean;
  label?: string;
  name?: string;
  onBlur?: (e: FocusEvent<HTMLInputElement>) => void;
  onChange?: (value: string) => void;
  onEnterKeyPress?: (event: KeyboardEvent<HTMLInputElement>) => void;
  value?: string;
};
export const PhoneInput = ({
  className,
  disabled,
  error,
  errorClassName,
  inputProps,
  isReadonly,
  isRequired,
  label,
  name,
  onBlur,
  onChange,
  onEnterKeyPress,
  value
}: Props) => {
  const handleKeyDown = (event: KeyboardEvent<HTMLInputElement>) => {
    if (event.key === 'Enter' && onEnterKeyPress) {
      onEnterKeyPress(event);
    }
  };
  return <div className={styles.wrapper} data-sentry-component="PhoneInput" data-sentry-source-file="PhoneInput.tsx">
      {label && <Text className={inputStyles.label} color='text-gray' type='p4'>
          {label}
        </Text>}
      <ReactPhoneInput containerClass={clsx(styles.reactPhoneInput, error && inputStyles.isError, className, inputStyles.wrapper, inputStyles.hidePlaceholderOnFocus, isReadonly && styles.readonly)} containerStyle={{
      '--flag-ua': `url(${flagUa.src})`
    } as Record<string, unknown>} country='ua' disabled={disabled} inputClass={clsx(inputStyles.input)} inputProps={{
      ...inputProps,
      name
    }} onBlur={onBlur} onChange={value => {
      if (onChange) {
        onChange(value.startsWith('+') ? value : `+${value}`);
      }
    }} onKeyDown={handleKeyDown} placeholder='+38  (___)  ___  __  __' value={value} data-sentry-element="ReactPhoneInput" data-sentry-source-file="PhoneInput.tsx" />
      {isRequired && <Text className={styles.requiredAsterisk} color='red' tag='span' type='field_text'>
          *
        </Text>}
      {error?.message && <span className={clsx(inputStyles.errorMessage, errorClassName)}>{error.message}</span>}
    </div>;
};